import React from 'react';
import ReportContent from "./report-content.jsx";
import PrintTemplate from "../../../../../components/reports/print-reports/print-template.jsx";

const Content = ({reportData, data, entity, title, collapsed, printComponentRef, setLoading, listAttendants}) => {
    return (
        <>
            {
              reportData && data.length > 0  && (
                    <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
                        <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
                        <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>
                        <div className={"w-full mt-[25px] print:mt-[0]"}>
                            <ReportContent
                                data={reportData}
                                collapsed={collapsed}
                                listAttendants={listAttendants}
                            />
                        </div>
                    </PrintTemplate>
                )
            }
        </>
    );
};

export default Content;